import React from 'react'
import { Button } from 'core/components/button'
import { requiredMessage } from 'core/constants'
import { useForm } from 'core/hooks/form'
import { TextInput } from 'core/components/form/text-input'
import { API } from 'service'
import { CouponPDF } from 'core/utils/pdf'
import { Field } from 'core/components/form/field'

export const GratuityForm = ({ global: { modal }, route, basename }) => {
	const form = useForm(
		{
			displayName: ent => ent.name,
			initialEntity: {
				id: '',
			},
			validate: values => {
				const errors = {}

				if (!values.id) {
					errors.id = requiredMessage
				}

				return errors
			},
		},
		route,
	)

	const { entity, errors, touched, handleChange, submitting } = form

	return (
		<div className="kt-portlet">
			<div className="kt-portlet__head">
				<div className="kt-portlet__head-label">
					<span className="kt-portlet__head-icon">
						<i className="kt-font-brand fas fa-sync-alt" />
					</span>
					<h3 className="kt-portlet__head-title">Trocar Placa</h3>
				</div>
			</div>
			<div className="kt-portlet__body">
				<form
					onSubmit={ev => {
						ev.preventDefault()
						form.handleSubmit(data => {
							API.get(`gratuity.register/${data.id}`)
								.then(resp => {
									const coupon = resp.coupon
										.split(/\n/)
										.map(line => line.replace(/\{barcode\}/g, ''))
									const doc = new CouponPDF(coupon)
									doc.open(false)
									route.history.push(`${basename}`)
								})
								.catch(err => modal.alert(err.message))
								.finally(() => form.setSubmitting(false))
						})
					}}
				>
					<Field label="Código da Consulta">
						<TextInput
                            acceptEnter
                            autoFocus
							customClassName="form-control-xl"
							meta={{
								error: errors.id,
								touched: touched.id,
							}}
							onChange={(id, type) =>
								handleChange({
									path: 'id',
									type,
									values: { id },
								})
							}
							value={entity.id}
						/>
					</Field>

					<div className="col-lg kt-align-right">
						<Button
							customClassName="btn-secondary"
							disabled={submitting}
							icon="fas fa-arrow-right"
							loading={submitting}
							title="Confirmar"
						/>
					</div>
				</form>
			</div>
		</div>
	)
}
